import { useRouter } from 'next/router'
import { useContext } from 'react'

import { SessionContext } from '@/src/components/ContextProvider'
import { getPaymentRouterQueries } from '@/src/utils/route'

export function usePublishableKey(): string {
  const { publishableKey } = useContext(SessionContext)
  const router = useRouter()
  const routerQueries = getPaymentRouterQueries(router)

  return publishableKey || routerQueries.publishableKey || ''
}
